import ClassOrganizer from './components/ClassOrganizer';
import { useAuthContext } from './context/AuthContext';
import {useSchedule} from "./hooks/useSchedule";
import {useCanvas} from "./hooks/useCanvas";
import {useClassroomContext} from "./context/ClassroomContext";
import { recentClass } from "./utils/dateUtils";

const CourseEditor = () =>{
    const { googleUser } = useAuthContext();
    const schedule = useSchedule();
    const { canvasEvents, canvasCourses } = useCanvas(googleUser);
    const { classes } = useClassroomContext();

    return(
        <div>
            <h1>
                course editor my guys
                
            </h1>
            <ClassOrganizer
                googleClasses={classes.filter(recentClass)}
                canvasEvents={canvasEvents}
                canvasCourses={canvasCourses} // ← add this
                schedule={schedule}
            />
        </div>
    );
}

export default CourseEditor;